import { Audience } from 'shared/models/auth';
import DevsiteEnv from '../DevsiteEnv';

export const shouldUseGatewayAuth = (platform?: Audience | null): boolean =>
  DevsiteEnv.GATEWAY_ROUTED_API_ENABLED && platform === Audience.OPEN_DEVELOPER;

export const isHttpOnlyCookieAuth = (platform?: Audience | null): boolean =>
  DevsiteEnv.BFF_ENABLED || (DevsiteEnv.HTTP_ONLY_AUTH_ENABLED && shouldUseGatewayAuth(platform));

export type GatewayMethod = 'devsite-bff' | 'public-api' | 'subdomain';

export const getGatewayMethod = (platform?: Audience | null): GatewayMethod => {
  if (DevsiteEnv.BFF_ENABLED) return 'devsite-bff';
  if (shouldUseGatewayAuth(platform)) return 'subdomain';
  return 'public-api';
};
